export function saltarBeneficiarios(observations) {
  return observations && (observations.includes("EC04") || observations.includes("EC05"));
}

export function saltarDependientes(observations) {
  return (
    observations &&
    (observations.includes("EC01") ||
      observations.includes("EC06") ||
      observations.includes("EC07") ||
      observations.includes("EC08"))
  );
}

export function planType(observations) {
  if (observations.includes("EC01")) {
    return ["V"];
  }
  if (observations.includes("EC02")) {
    return ["V", "G"];
  }
  if (observations.includes("EC03")) {
    return ["V", "G", "D"];
  }
  if (observations.includes("EC04")) {
    return ["G"];
  }
  if (observations.includes("EC05")) {
    return ["G", "D"];
  }
  if (observations.includes("EC06")) {
    return ["V", "A"];
  }
  if (observations.includes("EC07")) {
    return ["A"];
  }
  return [];
}
